<!-- Modal -->
<div class="modal fade" [id]="id" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    
    <div class="modal-content">

        <div class="modal-header">
            <h5 class="modal-title" id="modalLabel">{{header}}</h5>
            <button type="button" class="close" aria-label="Close" (click)="proceedCancel()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
    
          <div class="modal-body">
              <form>
                <div class="row">
                  <div class="mb-2 col-md-6">
                    <label for="password">Password *</label>
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('password')}" name="password" placeholder=""
                      type="password" [(ngModel)]="password">
                    <div class="invalid-feedback"> {{error('password')}} </div>
                  </div>
                </div>
                <div class="row">
                  <div class="mb-2 col-md-6">
                    <label for="confirmPassword">Confirm Password *</label>
                    <input class="form-control" [ngClass]="{'is-invalid': !!error('confirmPassword')}" name="confirmPassword"
                      placeholder="" type="password" [(ngModel)]="confirmPassword">
                    <div class="invalid-feedback"> {{error('confirmPassword')}} </div>
                  </div>
                </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="proceedYes()">Yes</button>
                <button type="button" class="btn btn-link" (click)="proceedCancel()">Cancel</button>
              </div>
    </div>

  

  </div>
</div>
